export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/MG-852e7a321cbd1f12787e5081a0ac9ce3.png";